import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { OffboardingAlertContainer } from '@/console/features/general-settings/components/offboarding/offboarding-alert/offboarding-alert.styled';
import { InfoIcon } from '@/shared/assets/icons/info-icon';
import { useDateUtils } from '@/shared/hooks/use-date-utils/use-date-utils';
import { useReadOffboardingQuery } from '@/shared/redux/api/offboarding/offboarding-api';

export const OffboardingAlert = () => {
  const { t } = useTranslation();
  const { formatLocalTime } = useDateUtils();
  const { data } = useReadOffboardingQuery();

  const offboarding = data?.readAllOffboardings.items?.[0];

  if (!offboarding) {
    return null;
  }

  return (
    <OffboardingAlertContainer>
      <InfoIcon size="1.25rem" variant="error" />
      <Stack gap="0.25rem">
        <Typography component="p" variant="p8">
          {t('settings:offboarding.offboarding_alert')}
        </Typography>
        <Typography component="p" variant="p7">
          {formatLocalTime(offboarding.deactivationTimestamp)}
        </Typography>
      </Stack>
    </OffboardingAlertContainer>
  );
};
